import React from "react";
import { Skeleton } from "@origin-digital/ods-lab";
import { SuggestionHeading } from "./styles";
import { SearchResultItemSkeleton } from "../SearchResults/SearchResultItemSkeleton";

export const SearchEmptyStateSkeleton = (): JSX.Element => (
  <div data-id="search-empty-state-skeleton">
    <Skeleton variant="text" width="40%" backgroundColor="light">
      <SuggestionHeading>&nbsp;</SuggestionHeading>
    </Skeleton>
    <SearchResultItemSkeleton dataId="search-empty-skeleton-1" />
    <SearchResultItemSkeleton dataId="search-empty-skeleton-2" />
    <SearchResultItemSkeleton dataId="search-empty-skeleton-3" />
  </div>
);
